import { Flex, Text, UnstyledButton } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Tooltip } from 'src/design-system/Tooltip';

type Props = {
  label: string;
  onClick: () => void;
  tooltip?: string;
};

export function SelectedClientPill({ label, onClick, tooltip }: Props) {
  const pill = (
    <UnstyledButton onClick={onClick} aria-label={`Remove ${label}`} style={{ borderRadius: 20 }}>
      <Flex
        align="center"
        gap={12}
        pl={20}
        pr={20}
        py="xs"
        bg="gray.0"
        style={{ borderRadius: 20 }}
      >
        <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {label}
        </Text>
        <IconX size={20} color="var(--mantine-color-gray-10)" style={{ flexShrink: 0 }} />
      </Flex>
    </UnstyledButton>
  );

  if (!tooltip) return pill;

  return (
    <Tooltip label={tooltip} position="bottom">
      {pill}
    </Tooltip>
  );
}
